import {
  Navbar,
  Nav,
  NavbarBrand,
  NavItem,
  NavLink,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { logoutUser } from "@/api";
import assetUrl from "@/assets/logo.png";
import { useRouter } from "@tanstack/react-router";
import { useCallback } from "react";
import { useUser } from "@/hooks";

export const NavbarComponent: React.FC = () => {
  const imgUrl = new URL(assetUrl, import.meta.url).href;
  const router = useRouter();
  const onLogout = useCallback(() => {
    logoutUser().then(() => router.invalidate());
  }, [router]);
  const user = useUser();

  return (
    <Navbar color="light" expand="md">
      <Nav navbar className="align-items-center">
        <NavbarBrand href="/">
          <img src={imgUrl} alt="CAASA Logo" width="48" />
        </NavbarBrand>
        <NavItem>
          <NavLink href="/">Home</NavLink>
        </NavItem>
      </Nav>
      <Nav>
        {user ? (
          <UncontrolledDropdown
            inNavbar
            nav
            title={user.name}
            id="basic-nav-dropdown"
          >
            <DropdownToggle nav caret>
              {user.name}
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem onClick={onLogout}>Logout</DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        ) : (
          <Button
            color="link"
            onClick={() =>
              (window.location.href = `/auth/login?returnTo=${window.location.href}`)
            }
          >
            Login
          </Button>
        )}
      </Nav>
    </Navbar>
  );
};
